import { createContext, useContext, useState } from 'react'
import T, { LANGUAGES, interp } from '../i18n/translations'
import { readStored, writeStored } from '../utils/safeStorage'

const LangContext = createContext()

export function LangProvider({ children }) {
  // Through safeStorage: this runs during the first render, and localStorage
  // throws outright with site data blocked or in an iframe with third-party
  // cookies off — so an unguarded read here white-screened the whole app
  // rather than costing it a language preference.
  const [lang, setLang] = useState(() => readStored('sb_lang', 'en') || 'en')

  function t(key, vars) {
    const str = T[lang]?.[key] ?? T['en']?.[key] ?? key
    return vars ? interp(str, vars) : str
  }

  function setLanguage(code) {
    setLang(code)
    // Best effort. The language still changes for this session if the write
    // is refused; it simply will not be remembered next time.
    writeStored('sb_lang', code)
  }

  return (
    <LangContext.Provider value={{ lang, setLanguage, t, LANGUAGES }}>
      {children}
    </LangContext.Provider>
  )
}

export function useLang() { return useContext(LangContext) }
